<div class="nd-notification-details-main page-content-notification-details">
    <owc-breadcrumb>
        <owc-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs; last as isLast">
            <span *ngIf="!isLast" class="mat-caption" (click)="navigateTo($event, breadcrumb.url)"
                style="cursor: pointer;">
                {{ breadcrumb?.label }}
            </span>
            <span *ngIf="isLast" class="mat-small">
                {{ breadcrumb?.label }}
            </span>
        </owc-breadcrumb-item>
    </owc-breadcrumb>
    <p class="customerTitle">{{notificationLabel}}</p>
  
  <div *ngIf="notificationData.Status === 'Superseded'" 
       style="background-color: #FFF4E5; border-left: 4px solid #FF8B00; padding: 12px 16px; margin-bottom: 16px; border-radius: 4px; display: flex; align-items: center; gap: 8px;">
    <span style="color: #663C00; font-size: 14px; font-weight: 500;">
      This notification has been superseded by 
      <a *ngIf="notificationData.SupersededByLocalId" 
         (click)="viewSupersedingNotification(notificationData)" 
         style="color: #0066cc; font-weight: 700; cursor: pointer; text-decoration: underline;">
        {{ notificationData.SupersededByLocalId }}
      </a>
      <strong *ngIf="!notificationData.SupersededByLocalId">a newer version</strong>
    </span>
  </div>

    <div class="card-container" style="display:flex; width:100%; justify-content: space-between; margin:auto">

        <owc-card oneCard class="card-list" style="max-width:39.5%; width:100%; height: auto;">
            <owc-component-header>
                <div class="mat-title">General information</div>
            </owc-component-header>
            <div style="display: block;overflow-x: auto;padding-top: 10px; margin-left:16px;">
                <div class="item">
                    <div class="title">Status</div>
                    <div class="chip-value">
                        <owc-chip class="notification-list-source-chip truncate-text" oneChip
                            oneChipAppearance="outline">
                            <img src="assets/{{notificationStatusIcon}}" class="chip-icon">{{ notificationData?.Status
                            }}
                        </owc-chip>
                        <div class="icon-cell">
                            <owc-icon-button family="outlined" [id]="'menu-anchor'"
                                icon="more_vertical" [disabled]="notificationData.Status === 'Superseded'"></owc-icon-button>
                            <owc-menu #statusMenu [anchor]="'menu-anchor'" limit="3" position="left">
                                <owc-list-item (click)="openStatusDialog()">Set to "Complete"</owc-list-item>
                                <owc-list-item (click)="openDueDateRemindersDialog()"
                                    [disabled]="notificationData.Status === 'Completed' || notificationData.Status === 'Overdue' || areAllAccountsFeedbackOverdue()">
                                    <span>Due date and reminders</span>
                                </owc-list-item>
                            </owc-menu>
                        </div>

                        <owc-modal-dialog [(ngModel)]="setCompleteButtonVisible" size="small"
                            class="complete-status-modal">
                            <owc-component-header slot="header" class="modal-header">
                                Set status to "Complete"
                            </owc-component-header>
                            <div class="modal-body">
                                <owc-typography variant="body2" style="margin-left: 15px;">
                                    Are you sure you want to set the status of this notification to "Complete"? The
                                    recipients will not be able to provide feedback anymore.
                                </owc-typography>
                            </div>
                            <owc-component-footer slot="footer" class="modal-footer">
                                <owc-button class="cancel-btn" (click)="closeDeleteModal()">Cancel</owc-button>
                                <owc-button class="confirm-btn" (click)="confirmDelete()">Yes, set to
                                    "Complete"</owc-button>
                            </owc-component-footer>
                        </owc-modal-dialog>

                    </div>
                </div>
                <div class="item" style="margin-top: 10px;">
                    <div class="title">Creation date</div>
                    <div class="value truncate-text" [title]="notificationData.CreationDate">{{
                        appUtil.formatDateOnly(notificationData.CreationDate ) }}</div>
                </div>
                <div class="item">
                    <div class="title">Local ID</div>
                    <div class="value truncate-text" [title]="notificationData.LocalId">
                        {{ notificationData.LocalId }}
                    </div>
                </div>
                <div class="item">
                    <div class="title">Global ID</div>
                    <div class="value truncate-text" [title]="notificationData.GlobalId">
                        {{ notificationData.GlobalId }}
                    </div>
                </div>
                <div class="item">
                    <div class="title" style="font-weight: bold;">Note</div>
                    <div class="value truncate-text" style="width:100%"
                        [title]="appUtil.formatDateWithTimeUptoSec(notificationData.NoteDate)">
                        {{ appUtil.formatDateWithTimeUptoSec(notificationData.NoteDate) }}
                    </div>
                    <div style="text-align: right; width: 100%;">
                        <button one-icon-button mat-icon-button (click)="addNoteForm()" style="margin-right: 10px;" [disabled]="notificationData.Status === 'Superseded'">
                            <owc-icon name="write" family="outlined"></owc-icon>
                        </button>
                    </div>
                    <owc-modal-dialog [(ngModel)]="visibleAddNote" size="small">
                        <dl-add-note [data]="data" (noteAdded)="onNoteAdded($event)"></dl-add-note>
                    </owc-modal-dialog>
                </div>
            </div>
        </owc-card>

        <owc-card class="card-list-special" style="max-width:59.5%; width:100%;overflow: hidden; height: auto;">
            <owc-component-header>
                <div class="mat-title">Status</div>
            </owc-component-header>
            <div style="display: flex; align-content: center; justify-content: center;">
                <div style="flex:0;">
                    <div
                        style="padding: 8px 90px; color: #0066cc; border-bottom: 2px solid #0066cc; cursor: pointer; font-weight: 500; display: inline-block; margin-bottom: 16px;">
                        Delivery


                </div>
                    <div class="notification-chart"
                        style="overflow: hidden; display: flex; justify-content: center; align-items: center;">
                        <canvas #donutCustomer1>Chart</canvas>
                    </div>
                </div>
                <div style="flex:0;" *ngIf="feedbackEnabled">
                    <div  style="padding: 8px 90px; color: #0066cc; border-bottom: 2px solid #0066cc; cursor: pointer; font-weight: 500; display: inline-block; margin-bottom: 16px;">
                        Feedback
                    </div>
                    <div class="notification-chart"
                        style="overflow: hidden; display: flex; justify-content: center; align-items: center;">
                        <canvas #donutCustomer2>Chart</canvas>
                    </div>
                </div>


            </div>
        </owc-card>

    </div>

    <div style="display: block; margin-top:12px;">
        <owc-card oneCard class="card-list" style="width:100%">
            <owc-component-header>
                <div class="mat-title">Attachments</div>
            </owc-component-header>
            <div style="display: block; margin-left:16px">
                <ng-container
                    *ngIf="notificationData.NotificationDocuments && notificationData.NotificationDocuments.length > 0 && notificationData.NotificationDocuments[0].PIMID">
                    <div class="nd-files-list" *ngFor="let attachment of notificationData.NotificationDocuments">
                        <div class="single-file">
                            <div class="info" (click)="downloadDocument(attachment.PIMID, attachment.FileExtension)">
                                <owc-icon class="one-icons file-icon">{{
                                    appUtil.formatFilesIcons(attachment.FileExtension) }}</owc-icon>
                                <span class="name truncate-text" style="margin-left:20px" [title]="attachment.Title">
                                    {{ attachment.Title }}
                                </span>
                                <span class="globalTag">Global</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="notificationData.NotificationAttachments && notificationData.NotificationAttachments.length > 0">
                    <div class="nd-files-list" *ngFor="let attachmentData of notificationData.NotificationAttachments">
                        <div class="single-file">
                            <div class="info"
                                (click)="downloadAttachment(attachmentData.FileName, notificationData.NotificationId)">
                                <owc-icon class="one-icons file-icon">{{
                                    appUtil.formatFilesIcons(attachmentData.FileName) }}</owc-icon>
                                <span class="name truncate-text" style="margin-left:20px"
                                    [title]="attachmentData.FileName">
                                    {{ attachmentData.FileName }}
                                </span>
                                <span class="localTag">Local</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="(!notificationData.NotificationDocuments || notificationData.NotificationDocuments.length === 0 || !notificationData.NotificationDocuments[0]?.PIMID) && (!notificationData.NotificationAttachments || notificationData.NotificationAttachments.length === 0)"
                    style="color: red; font-style: italic; padding-bottom: 10px;">
                    No attachments added.
                </div>
            </div>
        </owc-card>
    </div>

    <!-- Accounts Table -->
    <div class="notification-details-container" style="margin-top:12px;">

        <owc-card class="notification-recepient-list" style="box-shadow: none;">

            <div class="notification-header">

                <div class="notification-list-title">Accounts</div>

                <div class="notification-details-search">
                    <dl-notification-search style="margin-top:0px;"
                        (searchValue)="onSearchValue($event)"></dl-notification-search>
                    <div title="Click to open filter Dialog" class="notification-details-filter-icon"
                        (click)="filterData()">
                        <owc-icon name="filter" family="outlined"></owc-icon>
                        <span class="filter-text">Filter</span>
                    </div>
                </div>
                <owc-modal-dialog [(ngModel)]="visibleFilterDialog" class="filter-dialog">
                    <dl-filter-overlay-dialog [data]="data"
                        (closed)="onFilterDialogClosed()"></dl-filter-overlay-dialog>
                </owc-modal-dialog>

                <div style="text-align: right; position: relative;" title="Click to configure columns">
                    <span #settingsIcon>
                        <owc-icon class="one-icons" id="menu-anchor-1" name="settings" style="cursor: pointer;"
                            (click)="toggleMenu()"></owc-icon>
                    </span>
                    
                    @if (menuVisible) {
                    <div class="columns-dropdown-menu" [ngStyle]="dropdownPosition" (click)="$event.stopPropagation()">
                      <div class="dropdown-header">
                        <span class="dropdown-title">Show/Hide columns</span>
                        <owc-icon name="chevron-up" style="cursor: pointer;" (click)="closeMenu()"></owc-icon>
                      </div>
                      
                      <div class="dropdown-options">
                        <!-- All Columns header row -->
                        <div class="dropdown-option dropdown-option-header" (click)="masterToggleAccount()">
                          <owc-checkbox 
                            style="height: 25px; pointer-events: none;"
                            [checked]="isAllSelectedAccount()"
                            [indeterminate]="hasValueAccount() && !isAllSelectedAccount()">
                          </owc-checkbox>
                          <span class="option-label option-label-header">All Columns</span>
                        </div>
                        
                        <!-- Individual column options -->
                        @for (element of accountDataSource; track $index) {
                        <div class="dropdown-option" (click)="toggleSelectionAccount(element)">
                          <owc-checkbox 
                            style="pointer-events: none;"
                            [checked]="isSelectedAccount(element)" 
                            [disabled]="element.disabled">
                          </owc-checkbox>
                          <span class="option-label">{{element.key}}</span>
                        </div>
                        }
                      </div>
                      
                      <div class="dropdown-footer">
                        <owc-button color="primary" mat-flat-button (click)="getAccountSelectedColumns()">Apply</owc-button>
                      </div>
                    </div>
                    }
                </div>



            </div>

        </owc-card>

        <dl-notification-accounts-table [isSetCom]="isSetCom" [notificationLabel]="notificationLabel"
            [contactDataDetails]="contactDataObj" [contactDetails]="accountDataObj"
            [notificationDetails]="notificationDataObj" [selectedRecepientColumns]="accountSelectedColumns">
        </dl-notification-accounts-table>

    </div>

    <!-- Due Date Reminder Modal Dialog -->
    <owc-modal-dialog size="large" [(ngModel)]="dueDateReminderDialogVisible">

        <dl-due-date-reminder-popup [dialogData]="dueDateReminderDialogData"
            (closeDialog)="onDueDateReminderDialogClose($event)">
        </dl-due-date-reminder-popup>
    </owc-modal-dialog>

</div>